import { useT } from '../lib/i18n';

/**
 * A number a guest changes one at a time.
 *
 * Two buttons and a readout rather than `<input type=number>`: a numeric input
 * on a phone opens a keyboard to change "2" to "3", and the spinners it draws
 * on a desktop are around 12px tall. The buttons are `--tap` square, so this is
 * usable with a thumb, which the native control is not.
 *
 * The value is read aloud with its own label, because "2" on its own tells a
 * screen-reader user nothing about which of four counters they are on.
 */
export function Stepper({ value, min, max, onChange, name, describedBy }: {
  value: number;
  min: number;
  max: number;
  onChange: (next: number) => void;
  /** What is being counted, already translated. Used in the button labels. */
  name: string;
  describedBy?: string;
}) {
  const t = useT();
  return (
    <div className="pw-stepper">
      <button
        type="button"
        onClick={() => onChange(Math.max(min, value - 1))}
        disabled={value <= min}
        aria-label={t('party.fewer', { what: name })}
      >
        &minus;
      </button>
      <output className="pw-stepper-value" aria-describedby={describedBy}>
        {value}
      </output>
      <button
        type="button"
        onClick={() => onChange(Math.min(max, value + 1))}
        disabled={value >= max}
        aria-label={t('party.more', { what: name })}
      >
        +
      </button>
    </div>
  );
}
